var React = require('react');

function PinInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M19.622 0.984375C11.8338 0.984375 5.49768 7.3205 5.49768 15.1086C5.49768 24.7739 18.1376 38.9631 18.6757 39.5625C19.1812 40.1254 20.0637 40.1245 20.5683 39.5625C21.1064 38.9631 33.7463 24.7739 33.7463 15.1086C33.7462 7.3205 27.4101 0.984375 19.622 0.984375ZM19.622 22.2149C15.7036 22.2149 12.5158 19.0271 12.5158 15.1086C12.5158 11.1902 15.7036 8.00239 19.622 8.00239C23.5404 8.00239 26.7282 11.1903 26.7282 15.1087C26.7282 19.0271 23.5404 22.2149 19.622 22.2149Z","fill":"#F29100"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"39","height":"39","fill":"white","transform":"translate(0.121948 0.984375)"})))]);
}

PinInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = PinInline;

PinInline.default = PinInline;
